module.exports = __webpack_public_path__ + "static/media/MentorGerald.8bce2626.jpeg";